const COOLDOWN_CONFIG = {
    default: { long: 60000, short: 10000 },
    GetTasksDataDetail: { long: 60000, short: 10000 },
    GetExternalSystemTasks: { long: 60000, short: 10000 },
    GetMaterialOrder2: { long: 60000, short: 10000 },
    GetMaterialOrderParam: { long: 30000, short: 10000 },
};

const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

const STORAGE_PREFIX = 'cooldown_';

class CooldownManager {
    _getDuration(key) {
        const entry = COOLDOWN_CONFIG[key] ?? COOLDOWN_CONFIG.default;
        return entry.long;
    }

    _getDurationByDateRange(key, startDate, endDate) {
        const entry = COOLDOWN_CONFIG[key] ?? COOLDOWN_CONFIG.default;
        const rangeMs = new Date(endDate) - new Date(startDate);
        return rangeMs > ONE_MONTH_MS ? entry.long : entry.short;
    }

    startCooldown(key, durationMs) {
        const duration = durationMs != null ? durationMs : this._getDuration(key);
        localStorage.setItem(STORAGE_PREFIX + key, Date.now() + duration);
    }

    startCooldownByDateRange(key, startDate, endDate) {
        const duration = this._getDurationByDateRange(key, startDate, endDate);
        localStorage.setItem(STORAGE_PREFIX + key, Date.now() + duration);
    }

    isOnCooldown(key) {
        const raw = localStorage.getItem(STORAGE_PREFIX + key);
        if (!raw) return { active: false, remainingMs: 0 };
        const expiresAt = Number(raw);
        const remainingMs = expiresAt - Date.now();
        if (remainingMs <= 0) {
            localStorage.removeItem(STORAGE_PREFIX + key);
            return { active: false, remainingMs: 0 };
        }
        return { active: true, remainingMs };
    }

    clearCooldown(key) {
        localStorage.removeItem(STORAGE_PREFIX + key);
    }

    clearAll() {
        Object.keys(localStorage)
            .filter(k => k.startsWith(STORAGE_PREFIX))
            .forEach(k => localStorage.removeItem(k));
    }

    setDefaultDuration(durationMs) {
        COOLDOWN_CONFIG.default.long = durationMs;
    }

    setCooldownDuration(key, durationMs) {
        if (!COOLDOWN_CONFIG[key]) COOLDOWN_CONFIG[key] = { ...COOLDOWN_CONFIG.default };
        COOLDOWN_CONFIG[key].long = durationMs;
    }

    setCooldownShortDuration(key, durationMs) {
        if (!COOLDOWN_CONFIG[key]) COOLDOWN_CONFIG[key] = { ...COOLDOWN_CONFIG.default };
        COOLDOWN_CONFIG[key].short = durationMs;
    }
}

const cooldownManager = new CooldownManager();

export default cooldownManager;
